import { defineMessages } from 'react-intl';

export default defineMessages({
  vehicle: {
    id: 'expert_expertise_victim_table.vehicle_title',
  },
  courtFileNumber: {
    id: 'expert_expertise_victim_table.court_file_number',
  },
  lastName: {
    id: 'expert_expertise_victim_table.last_name',
  },
  firstName: {
    id: 'expert_expertise_victim_table.first_name',
  },
  expertiseDate: {
    id: 'expert_expertise_victim_table.expertise_date',
  },
  city: {
    id: 'expert_expertise_victim_table.city',
  },
  reference: {
    id: 'fee_note.mission_reference',
  },
  registrationNumber: {
    id: 'claims.registration_number',
  },
});
